/* eslint-disable i18n/no-russian-character */
const ruComponents = {
    accessFeatures: {
        noCategory: "Без категории",
        add: {
            title: "Новый доступ",
            helperText: "Если не указано, наследуется от родителя",
            error: "Ошибка при создании нового доступа!",
            success: 'Создан новый доступ "%s"',
        },
    },
    accessParams: {
        title: "Доступы",
        roles: "Роли",
        accessFeatures: "Доступы",
        accessFeatureCategories: "Категории доступов",
    },
    calendar: {
        messages: {
            allDay: "Весь день",
            previous: "Назад",
            next: "Вперед",
            today: "Сегодня",
            month: "Месяц",
            week: "Неделя",
            day: "День",
            agenda: "Повестка дня",
            date: "Дата",
            time: "Время",
            event: "Событие",
            noEventsInRange: "Нет событий в этом диапазоне.",
            showMore: (total: number) => `+ ещё (${total})`,
        },
    },
    camera: {
        camera: "Камера",

        title: "Сделайте фото",
        errors: {
            overconstrained: "Ваша камера не поддерживает минимального разрешения",
            permissionDenied:
                "Доступ запрещен. Пожалуйста, дайте разрешение на использование камеры для сайта",
            notFound: "Камера не обнаружена на устройстве",
            blobNotCreated: "Ошибка при создании изображения",
            recordingError: "Ошибка при попытке записать видео",
            lostMediaRecorder: "Потерян объект MediaRecorder",
            stopRecord: "Ошибка при остановке видеосъемки",
            recordedChunksLength: "Проблемы с записанным видео! Перезапишите видео",
            unknown: "Неизвестная ошибка",
        },
        errorMessages: {
            noCameraAccessible:
                "Нет доступа к камере. Подключите камеру или попробуйте в другом браузере.",
            permissionDenied:
                "Доступ запрещен. Пожалуйста, дайте разрешение на использование камеры для сайта.",
            switchCamera:
                "Невозможно переключить камеру на другую, потому что доступно только одна.",
            canvas: "Canvas не поддерживается.",
            noGetPhoto: "Не удалось получить фото",
        },
    },
    comments: {
        tooltip: {
            upload: "Добавить файл, максимальный размер %s",
        },
        errors: {
            addComment: "Ошибка при попытке добавить комментарий",
        },
    },
    confirm: {
        title: "Вы уверены?",
        okText: "Да",
        noText: "Отмена",
        confirmDelete: {
            title: "Удаление",
            text: "Вы уверены, что хотите это удалить?",
            okText: "Да, удалить",
            noText: "Отмена",
        },
    },
    inputContacts: {
        noRecords: "Нет контактов",
        addTitle: "Добавить контакт",
        editTitle: "Редактировать контакт",
        fields: {
            contactPhone: "Номер телефона",
            contactEmail: "E-mail",
            contactTelegram: "Логин",
            contactType: "Тип контакта",
            description: "Описание",
            isMain: "Предпочтительный способ связи",
        },
        actions: {
            copy: "Скопировать",
            edit: "Редактировать",
            delete: "Удалить",
            copied: 'Текст "%s" скопирован в буфер обмена',
            whatsApp: "в WhatsApp",
            telegram: "в Telegram",
        },
        deleteConfirm: {
            title: "Удалить контакт",
            text: 'Вы уверены, что хотите удалить контакт "%s"',
        },
        errors: {
            required: "Поле обязательно к заполнению",
            email: "Укажите корректный Email",
            phone: "Укажите корректный номер телефона",
            telegram: "Укажите корректный логин в Telegram",
        },
    },
    crud: {
        loader: "Идет получение данных. Подождите...",
        deleteConfirm: {
            title: "Удаление записей",
            text: "Вы уверены что хотите удалить %p#records#?",
            okText: "Да, удалить",
        },
        errors: {
            list: "Не удалось получить данные с сервера",
            delete: "Не удалось удалить выбранные записи",
            edit: "Не удалось получить запись с сервера",
            save: "Не удалось сохранить данные на сервере",
        },
    },
    crudAsync: {
        loader: "Идет получение данных. Подождите...",
        editTitle: "Редактирование записи",
        addTitle: "Новая запись",
        deleteConfirm: {
            title: "Удаление записей",
            text: "Вы уверены что хотите удалить %p#records#?",
            okText: "Удалить",
        },
        success: {
            delete: "Удалено %p#records#",
            save: "Данные отредактированы",
        },
        errors: {
            list: "Не удалось получить данные с сервера!",
            delete: "Не удалось удалить выбранные записи!",
            edit: "Не удалось получить запись с сервера!",
            save: "Не удалось сохранить данные на сервере!",
            initialValue: "Не указаны данные по умолчанию",
        },
    },
    dateRange: {
        invalidDate: "Некорректная дата",
        startDate: "С",
        endDate: "По",
    },
    errorPage: {
        error: "Ошибка №%s",
        error0: "Внутренняя ошибка",
        error404: "Страница не найдена",
        errorMessage: "Текст ошибки",
        errorName: "Тип ошибки",
        toHome: "На главную",
    },
    filesManager: {
        addFile: "Добавить файл, максимальный размер %s",
        addFiles: "Добавить файлы, максимальный размер %s. Не более %s файлов за раз",
        deleteConfirm: {
            title: "Удалить файл",
            text: 'Вы уверены, что хотите удалить файл "%s"?',
            okText: "Да, удалить",
        },
        errors: {
            delete: "Не удалось удалить файл %s",
        },
    },
    fileShareFolder: {
        noFilesOrFolders: "Данная папка пуста",
        folders: "Папки",
        files: "Файлы",
        getLink: "Поделиться ссылкой",
        showFile: "Просмотр",
        downloadFile: "Скачать",
        config: {
            sortName: "По названию",
            sortNameDesc: "По названию (по убыванию)",
            sortDate: "По Дате изменения",
            sortDateDesc: "По Дате изменения (по убыванию)",
            sortSize: "По Размеру",
            sortSizeDesc: "По Размеру (по убыванию)",
        },
        links: {
            title: "Доступ по ссылке",
            link: "Ссылка",
            copy: "Скопировать в буфер обмена",
            copied: "Ссылка скопирована в буфер обмена!",
            toLink: "Перейти",
        },
        errors: {
            getFolderData: "Не удалось отобразить содержимое!",
            getFile: "Не удалось загрузить файл",
            getFolderLink: "Не удалось получить ссылку на папку!",
        },
    },
    form: {
        isRequired: "Поле обязательно к заполнению",
        minLength: "Поле должно иметь не менее %s символов",
        maxLength: "Поле должно иметь не более %s символов",
        min: "Значение должно быть не меньше %s",
        max: "Значение должно быть не больше %s",
        cancelBtn: "Отмена",
        submitBtn: "Сохранить",
        isUrl: "Укажите корректную ссылку",
        isNumber: "Значение должно быть числом",
        isDate: "Укажите корректную дату",
        isGuid: "Укажите корректный GUID",
        isPhone: "Укажите корректный номер телефона",
        isEmail: "Укажите корректный Email",
        isSelectValue: "Выберите значение из списка",
        pattern: "Поле содержит недопустимые символы",
        multiline: "Текст можно выводить в несколько строк",
    },
    goodTable: {
        loading: "Загрузка...",
        rowsPerPage: "Выводить по",
        noRecords: "Нет записей",
        noCsvExportData: "Нет записей для скачивания",
        records: "%s–%s из %s",
        filters: {
            value: "Значение",
            searchType: "Фильтр",
            sortType: "Сортировка",
            asc: "По возрастанию",
            desc: "По убыванию",
        },
        toolbar: {
            search: "Введите текст для поиска",
            csvExport: "Скачать",
        },
    },
    gradeStepSelect: {
        selectTitle: "Выберите шаг грейда",
        grade: "Грейд",
        errors: {
            getGradeSteps: "Не найдены шаги грейда",
        },
    },
    header: {
        profile: "Мой профиль",
        logout: "Выйти",
        search: {
            tooltip: "Поиск по урокам",
            notFound: "Ничего не найдено",
            found: "Найдено %p#records#",
            title: "Поиск уроков",
        },
        notifications: "Уведомления",
    },
    htmlEditor: {
        uploadFile: "Загрузить файл",
        video: {
            title: "Вставить ссылку на видео",
            link: "Ссылка на видео",
            cancel: "Отмена",
            ok: "Вставить",
            aspectRatio: "Соотношение сторон",
            aspectRatioVertical: "▯ Вертикальное",
            aspectRatioHorizontally: "▭ Горизонтальное",
            type: "Тип видео",
            typeYoutube: "YouTube",
            typeRutube: "Rutube",
            errors: {
                noVideoLink: "Укажите ссылку на видео",
                isNotLink: "Укажите корректную ссылку",
            },
        },
        iframe: {
            title: "Вставить iFrame",
            link: "Ссылка на iFrame",
            cancel: "Отмена",
            ok: "Вставить",
            aspectRatio: "Соотношение сторон",
            aspectRatioVertical: "▯ Вертикальное",
            aspectRatioHorizontally: "▭ Горизонтальное",
            errors: {
                isNotLink: "Укажите корректную ссылку",
                noVideoLink: "Укажите ссылку на iFrame",
            },
        },
        paste: {
            title: "Вставка текста",
            text: "Вы хотите вставить текст из Буфера обмена. Очистить формат?",
            cancel: "Нет, оставить как есть",
            ok: "Да, очистить",
        },
        errors: {
            fileExtFormat: "Данный тип файлов не поддерживается",
            fileUpload: "Ошибка при загрузке файла на сервер",
        },
        loading: "Подождите, редактор грузится",
    },

    image: {
        viewer: {
            errors: {
                load: "Не удалось загрузить изображение",
            },
            actions: {
                download: "Скачать",
                rotateRight: "Повернуть изображение  по часовой стрелке",
                rotateLeft: "Повернуть изображение против часовой стрелки",
                reset: "Сброс",
                close: "Закрыть",
            },
        },
        cropper: {
            actions: {
                rotateRight: "Повернуть изображение  по часовой стрелке",
                rotateLeft: "Повернуть изображение против часовой стрелки",
                reset: "Сброс",
                save: "Сохранить",
                close: "Закрыть",
            },
            selector: {
                tooltip: "Обрезать изображение",
                none: "Не обрезать",
                vertical: "Вертикально  (3 : 4)",
                horizontal: "Горизонтально (4 : 3)",
                square: "Квадрат (1 : 1)",
            },
        },
    },
    inputAudio: {
        errors: {
            add: "Не удалось добавить аудио файл",
        },
    },
    inputAutocomplete: {
        noOptionsText: "Ничего не найдено",
        insertSearchText: "Введите текст для поиска",
        selectAll: "Все",
    },
    inputClient: {
        title: "Поиск гостя",
        add: {
            title: "Новый гость",
            fields: {
                name: "Имя гостя",
                car: "Машина",
                category: "Категория",
                phone: "Номер телефона",
                email: "E-mail",
                telegram: "Telegram",
            },
            errors: {
                noContacts: "Укажите хотя бы один контакт",
                save: "Не удалось создать пользователя",
            },
        },
        search: {
            title: "Гости",
            searchText: "Текст для поиска",
            placeholder: "Введите номер телефона или имя гостя",
            onRecords: "По вашему запросу ничего не найдено",
            addAction: "Добавить нового гостя",
            fields: {
                name: "Имя",
                contact: "Контакт",
                createdDate: "Создан",
                category: "Категория",
                id: "ID",
            },
        },
    },
    inputImage: {
        addTitle: "Загрузить",
        deleteTitle: "Удалить изображение?",
        deleteText: "Вы уверены, что хотите удалить изображение?",
        simplePastePlaceholder: "Вставить из буфера обмена",
        insertImage: "Буфер обмена не содержит изображения",
    },
    inputHtml: {
        toolbar: {
            undo: "Отменить (Ctrl+Z)",
            redo: "Повторить (Ctrl+Y)",
            clearText: "Очистить весь текст",
            cleanHtml: "Очистить HTML от мусорных данных",
            toggleHtmlMode: "Переключить в режим HTML",
            previewHtml: "Предварительный просмотр HTML",
            bold: "Жирный текст (Ctrl+B)",
            italic: "Курсив (Ctrl+I)",
            underline: "Подчеркивание (Ctrl+U)",
            strikethrough: "Зачеркнутый текст",
            superscript: "Надстрочный индекс",
            subscript: "Подстрочный индекс",
            alignLeft: "Выровнять по левому краю",
            alignCenter: "Выровнять по центру",
            alignRight: "Выровнять по правому краю",
            alignJustify: "Выровнять по ширине",
            heading1: "Заголовок 1 уровня",
            heading2: "Заголовок 2 уровня",
            heading3: "Заголовок 3 уровня",
            blockquote: "Цитата",
            paragraph: "Обычный текст",
            numberedList: "Нумерованный список",
            bulletedList: "Маркированный список",
            decreaseIndent: "Уменьшить отступ",
            increaseIndent: "Увеличить отступ",
            fontFamily: "Шрифт",
            fontFamilyDefault: "Шрифт по умолчанию",
            sansSerif: "Без засечек",
            fontSize: "Размер шрифта",
            fontSizeDefault: "По умолчанию",
            textColor: "Цвет текста",
            backgroundColor: "Цвет фона",
        },
        link: {
            title: "Создать/редактировать ссылку",
            createTitle: "Создать ссылку",
            editTitle: "Редактировать ссылку",
            urlLabel: "URL",
            urlPlaceholder: "https://example.com",
            urlHelper: "Например: https://example.com, mailto:test@example.com",
            textLabel: "Текст ссылки",
            textPlaceholder: "Если оставить пустым, будет использован URL",
            textHelper: "Текст, который будет отображаться в ссылке",
            titleLabel: "Подсказка (title)",
            titlePlaceholder: "Подсказка, которая появляется при наведении",
            titleHelper: "Дополнительная информация о ссылке (необязательно)",
            openInNewWindow: "Открывать в новом окне",
            cancel: "Отмена",
            create: "Создать",
            update: "Обновить",
            delete: "Удалить ссылку",
            errors: {
                urlEmpty: "URL не может быть пустым",
                urlInvalid: "Введите корректный URL",
            },
        },
        fileUpload: {
            title: "Загрузить файл",
            button: "Загрузить файл",
            dialogTitle: "Загрузить файл",
            selectFile: "Выбрать файл",
            selectedFile: "Выбранный файл:",
            fileSize: "Размер:",
            fileSizeUnit: "МБ",
            textLabel: "Текст ссылки",
            textPlaceholder: "Текст, который будет отображаться как ссылка",
            textHelper: "Если оставить пустым, будет использовано имя файла",
            titleLabel: "Подсказка",
            titlePlaceholder: "Описание файла (опционально)",
            titleHelper: "Текст, который будет показываться при наведении на ссылку",
            cancel: "Отмена",
            upload: "Загрузить",
        },
        iframe: {
            title: "Вставить iframe",
            dialogTitle: "Вставить iframe",
            editTitle: "Редактировать iframe",
            linkLabel: "Ссылка",
            linkPlaceholder: "https://example.com/embed",
            linkHelper: "URL для встраивания в iframe",
            delete: "Удалить Iframe",
            deleted: "Iframe удален",
            errors: {
                linkEmpty: "Укажите ссылку для iframe",
                linkInvalid: "Введите корректную ссылку",
            },
        },
        video: {
            title: "Вставить ссылку на видео",
            editTitle: "Редактировать видео",
            link: "Ссылка на видео",
            type: "Тип видео",
            typeYoutube: "YouTube",
            typeRutube: "Rutube",
            errors: {
                noVideoLink: "Укажите ссылку на видео",
                isNotLink: "Укажите корректную ссылку",
            },
        },
        image: {
            title: "Вставить/редактировать изображение",
            button: "Изображение",
            createTitle: "Вставить изображение",
            editTitle: "Редактировать изображение",
            srcLabel: "URL изображения",
            srcPlaceholder: "https://example.com/image.jpg",
            selectImage: "Выберите файл изображения",
            selectedFile: "Выбранный файл",
            fileSize: "Размер файла",
            srcHelper: "Прямая ссылка на изображение",
            altLabel: "Альтернативный текст",
            altPlaceholder: "Описание изображения",
            titleLabel: "Заголовок (title)",
            titlePlaceholder: "Всплывающая подсказка",
            titleHelper: "Текст, который появляется при наведении на изображение",
            widthLabel: "Ширина",
            heightLabel: "Высота",
            sizeHelper: "Поддерживаются px и %. Оставьте пустым для автоматического размера",
            sizePlaceholder: "100px или 50%",
            styleLabel: "CSS стили",
            stylePlaceholder: "width: 100px; height: 50px; border-radius: 5px;",
            styleHelper: "Дополнительные CSS стили для изображения",
            proportionsLocked: "Пропорции заблокированы (изменения применяются пропорционально)",
            proportionsUnlocked: "Пропорции разблокированы (размеры можно изменять независимо)",
            cancel: "Отмена",
            create: "Вставить",
            created: "Создано",
            update: "Обновить",
            delete: "Удалить",
            deleted: "Удалено",
            uploadFile: "Загрузить файл",
            fromUrl: "Из URL",
            errors: {
                srcEmpty: "URL изображения не может быть пустым",
                srcInvalid: "Введите корректный URL изображения",
                altEmpty: "Альтернативный текст обязателен для доступности",
                invalidSize: "Размеры должны быть положительными числами",
            },
        },
        paste: {
            htmlDetected: "Обнаружен HTML в буфере обмена",
            htmlCleaned: "HTML автоматически очищен от мусорных данных",
            htmlCleanedDetails: "Удалены Word-специфичные теги и атрибуты",
            word: "из Microsoft Word",
        },
        preview: {
            title: "Предварительный просмотр HTML",
            htmlTab: "HTML код",
            previewTab: "Просмотр",
            copyHtml: "Скопировать HTML",
            copiedSuccess: "HTML код скопирован в буфер обмена",
        },
        aspectRatio: {
            title: "Соотношение сторон",
            vertical: "▯ Вертикальное",
            horizontally: "▭ Горизонтальное",
        },
    },
    inputTime: {
        invalidTime: "Некорректное время",
    },
    inputTimeDuration: {
        days: "Дней",
        hours: "Часов",
        minutes: "Минут",
        seconds: "Секунд",
    },
    inputVideo: {
        addTitle: "Загрузить",
        deleteTitle: "Удалить видео?",
        deleteText: "Вы уверены, что хотите удалить видео?",
        addVideo: "Добавить видео",
    },
    inputFile: {
        placeholder: "Файл не выбран",
    },
    inputLesson: {
        selectTitle: "Выберите урок из списка",
        multiplePlaceholder: "Выберите уроки",
    },
    inputLessonCatalog: {
        multiplePlaceholder: "Выберите каталоги уроков",
        title: "Каталог уроков",
        toSelect: "Выбрать",
    },
    journalQuestions: {
        minLength: "Минимальная длина ответа",
        maxLength: "Максимальная длина ответа",
        textMask: "Текстовая маска",
        lengthHint: "0 - без ограничения",
        minDate: "Минимальная дата",
        maxDate: "Максимальная дата",
        dateHint:
            "Относительно даты заполнения. Измеряется в днях тому назад. 0 - сегодняшний день. -1 - завтра",
        image: "Фото (варианты)",
        imagePhoto: "Сделать фото",
        imageGallery: "Выбрать из галереи",
        noImage: "Нет фото",
        userType: "Тип сотрудника",
        userTypeTradePoint: "Из кофейни",
        userTypeAll: "Все пользователи",
        minNumber: "Минимальное значение",
        maxNumber: "Максимальное значение",
        defaultNumber: "Значение по умолчанию",
        stepNumber: "Кол-во знаков после запятой",
        yesText: "Текст для Да",
        noText: "Текст для Нет",
        equipmentType: "Тип оборудования",
        selectValues: "Варианты ответов",
        errors: {
            minMaxLength: "Минимальная длина ответа не должна быть БОЛЬШЕ максимальной",
            minMaxDate: "Минимальная дата не должна быть МЕНЬШЕ максимальной",
            image: "Укажите варианты для фото",
            userType: "Укажите тип сотрудника",
            yesText: "Укажите текст для Да",
            noText: "Укажите текст для Нет",
            equipmentType: "Укажите тип оборудования",
            minMaxNumber: "Минимальное значение не должно быть БОЛЬШЕ максимального",
            minDefaultNumber: "Значение по умолчанию не должно быть МЕНЬШЕ минимального",
            maxDefaultNumber: "Значение по умолчанию не должно быть БОЛЬШЕ максимального",
            minLength: "Минимальная длина ответа %s символов",
        },
        types: {
            date: "Укажите дату",
            text: "Введите текст",
            image: "Изображение",
            yesNo: "Выберите значение",
            counter: "Введите число",
            select: "Выберите значение из списка",
        },
    },
    learning: {
        lesson: {
            toPrevStep: "Предыдущий шаг",
            toNextStep: "Продолжить",
            toFinish: "Завершить",
            toWaitingConfirm: "Запросить подтверждение",
            answers: {
                text: "Введите текст ответа",
                rightOrder: "Установите варианты в правильном порядке",
                test: "Выберите вариант ответа",
                multiTest: "Выберите варианты ответа",
            },
            errors: {
                toNextStep: "Не удалось отправить данные!",
            },
        },
        lessonStepError: {
            title: "Допущена ошибка",
            text: "Максимальное количество - %p#errors#. После этого урок будет провален!",
            correctAnswers: "Правильный ответ:",
            status: {
                completed: {
                    title: "Поздравляем!",
                    text: "Вы успешно прошли урок.",
                },
                expired: {
                    title: "Вы не успели",
                    text: "К сожалению вы не успели вовремя",
                },
                failed: {
                    title: "Урок провален",
                    textEmployee: "Слишком много ошибок. Обратитесь к менеджеру.",
                    text: "Слишком много ошибок. Обратитесь к сотруднику академии.",
                },
                terminated: {
                    title: "Урок отменен",
                    text: "Прохождение урока было отменено.",
                },
                waitingConfirm: {
                    title: "Урок ожидает подтверждения",
                    text: "Ожидайте, пока академия подтвердит прохождение урока.",
                    textEmployee: "Ожидайте, пока менеджер подтвердит прохождение урока.",
                },
            },
        },
        lessonTimer: {
            tooltip: "Осталось времени",
        },
        lessonErrors: {
            title: "Ошибки: %s из %s",
            titleNoMaxErrors: "Ошибок: %s",
        },
        gradeTreeViewer: {
            gradeTree: "Дерево грейдов",
            userNoGradeTrees: "Нет доступных деревьев грейдов. Обратитесь в Академию",
            annulatedStatus: "Аннулирован",
            new: "Новый",
        },
        gradeWarnings: {
            title: 'Грейд "%s" будет аннулирован %s',
        },
        gradeUserHistory: {
            noRecords: "Нет записей",
            fields: {
                comment: "Комментарий",
                type: "Действие",
                createdDate: "Дата",
                id: "ID",
            },
        },
        gradeStepList: {
            title: 'Грейд "%s". Пройдено %s из %s',
            adminStepActions: {
                toPass: "Выполнить",
                toRemove: "Провалить",
                toReset: "Аннулировать",
                toConfirm: "Подтвердить",
                toAssign: "Назначить",
            },
            adminGradeActions: {
                toPass: "Назначить грейд",
                toRemove: "Удалить грейд",
                toHistory: "История получения",
            },
        },
        errorFeedbackAdd: {
            title: "Обнаружена ошибка",
            titleTooltip: "отправить ошибку",
            text: "Введите текст, в чем заключается ошибка",
            save: "Отправить",
            selectedTextTitle: "Выделенный текст",
            success: {
                add: "Спасибо за ваше сообщение. Скоро мы все исправим.",
            },
            errors: {
                add: "Не удалось отправить сообщение об ошибке!",
            },
        },
    },
    listSortable: {
        tooltips: {
            start: "Нажмите и удерживайте нужный объект списка. Когда он станет активным начните его перемещать.",
            end: "Удерживая объект, переместите его в нужное место списка.",
        },
    },
    loader: {
        defaultText: "Идет загрузка сайта. Подождите...",
    },
    mediaViewer: {
        tooltip: {
            toPrev: "Предыдущий",
            toNext: "Следующий",
        },
    },
    navigationMenu: {
        banner: {
            title: "CMPortal",
            subtitle: "Корпоративный портал",
        },
    },
    page: {
        notifications: {
            polls: {
                title: "Доступно %s опросов!",
                text: "Перейти к опросам?",
            },
        },
    },
    password: {
        passwordLength: "Пароль должен иметь не менее 6 символов",
        passwordPattern: "Пароль должен содержать латинские буквы и арабские цифры",
        passwordType: "Неверный формат данных",
        confirm: "Подтверждение пароля",
        passwordMismatch: "Пароли не совпадают",
    },
    permissionChecker: {
        prompt: "Ожидание разрешения",
        denied: "%s запрещен. Пожалуйста, дайте разрешение на использование для данного сайта",
        camera: {
            noCameraAccessible:
                "Нет доступа к камере. Подключите камеру или попробуйте в другом браузере.",
            unknown: "Неизвестная ошибка",
        },
        notifications: {
            notSupported: "Уведомления не поддерживаются в данном браузере",
        },
    },
    privacyConsentConfirm: {
        title: "Согласие на обработку персональных данных",
        text: "Вы должны подтвердить согласие на обработку персональных данных, чтобы продолжить работу!",
        privacyPolicy: "Политикой обработки персональных данных",
        action: "Подтвердить",
        actionSwitcher:
            "Я принимаю условия политики компании в сфере обработки персональных данных и даю согласие на обработку и распространение своих персональных данных.",
        success: "Согласие на обработку персональных данных подтверждено",
        error: "Не удалось подтвердить согласие на обработку персональных данных!",
        loading: "Загрузка списка документов. Подождите...",
    },
    rating: {
        mark1: "Очень плохо",
        mark2: "Плохо",
        mark3: "Нормально",
        mark4: "Хорошо",
        mark5: "Отлично",
    },
    rRule: {
        result: "Следующие %s событий",
        variant: {
            monthlyDay: "По числам",
            monthlySetpos: "По дням недели",
            YEARLYDAY: "Каждый год (по числам)",
            YEARLYSETPOS: "Каждый год (по дням недели)",
            MONTHLY: "Каждый месяц",
            MONTHLYDAY: "Каждый месяц (по числам)",
            MONTHLYSETPOS: "Каждый месяц (по дням недели)",
            WEEKLY: "Каждую неделю",
            DAILY: "Каждый день",
            DAILYHOURS: "Каждый день (по часам)",
            HOURLY: "Каждый час",
        },
        interval: {
            YEARLYDAY: "год",
            YEARLYSETPOS: "год",
            MONTHLYDAY: "месяц",
            MONTHLYSETPOS: "месяц",
            WEEKLY: "неделю",
            DAILY: "день",
            HOURLY: "час",
        },
        fields: {
            startDate: "Дата начала",
            endDate: "Дата окончания",
            freq: "Повторять",
            interval: "Каждый",
            weekdays: "День",
            isOn: "Повторять событие",
            variant: "Вариант",
        },
        freq: {
            YEARLY: "Каждый%s год",
            MONTHLY: "Каждый%s месяц",
            WEEKLY: "Каждую%s неделю",
            DAILY: "Каждый%s день",
            HOURLY: "Каждый%s час",
        },
        days: {
            byhour: "Часы",
        },
        weekdays: {
            byweekdays: "День",
            0: "Понедельник",
            1: "Вторник",
            2: "Среда",
            3: "Четверг",
            4: "Пятница",
            5: "Суббота",
            6: "Воскресенье",
        },
        setpos: {
            bysetpos: "",
            t1: "Первый",
            t2: "Второй",
            t3: "Третий",
            t4: "Четвертый",
            lastDay: "Последний",
        },
        monthly: {
            day: "По числам",
            setpos: "По дням недели",
            lastDayMonthDay: "Последний день месяца",
            lastDaySetpos: "Последний",
            bymonthday: "Число",
            bymonth: "Месяц",
            1: "Январь",
            2: "Февраль",
            3: "Март",
            4: "Апрель",
            5: "Май",
            6: "Июнь",
            7: "Июль",
            8: "Август",
            9: "Сентябрь",
            10: "Октябрь",
            11: "Ноябрь",
            12: "Декабрь",
        },
        yearly: {
            on: "В",
            bymonth: "Месяц",
            bysetpos: "День",
            lastDayMonthDay: "Последний день месяца",
            lastDaySetpos: "Последний",
        },
    },
    signalR: {
        newMessage: "У вас новое оповещение",
    },
    selectAutocomplete: {
        noOptionsText: "Ничего не найдено",
        selectValue: "Укажите значение",
        selectAll: "Все",
        addOption: "Добавить",
    },
    spreadSheet: {
        revertChanges: "Отменить",
        saveChanges: "Сохранить",
        addRow: "Добавить строку",
        deleteRow: "Удалить",
        copyRow: "Копировать",
    },
    tableLogs: {
        title: "История изменений",
        noRecords: "Нет записей",
        action: "Действие",
        actions: {
            insert: "Добавление",
            update: "Редактирование",
            delete: "Удаление",
            softDelete: "Снятие с публикации",
            softRecover: "Восстановление",
        },
    },
    textWithMask: {
        maskError: "Укажите корректное значение",
    },
    treeViewer: {
        clearValue: "Удалить значение",
        selectValue: "Выберите значение",
        noValueText: "Не задано",
    },
    inputTag: {
        addLabel: "Укажите значение",
        addSelect: 'Добавить "%s"',
        addSelectWithCategories: 'Добавить в категорию "%s" тег "%s"',
        noTagsText: "Нет тегов",
    },
    tradePointFormatFlagSelect: {
        title: "Форматы кофеен",
    },
    videoViewer: {
        errors: {
            load: "Не удалось загрузить видео",
        },
        actions: {
            download: "Скачать файл",
            close: "Закрыть",
        },
    },
    voiceReader: {
        accessDenied:
            "Доступ к микрофону запрещен. Чтобы использовать функцию распознавания голоса - разрешите доступ к камере для данного сайта",
        tooltip: "Голосовой набор. Работает пока удерживаете кнопку нажатой",
    },
    wazzup24: {
        title: "Чат с пользователем %s",
        tooltip: "Открыть чат с пользователем в WhatsApp",
        errors: {
            getIframeUrl: "Не удалось открыть чат с пользователем",
        },
    },
    uploader: {
        imageUploader: {
            add: "Загрузить изображение",
            rotateLeft: "Повернуть влево",
            rotateRight: "Повернуть вправо",
            toCancel: "Отмена",
            toSave: "Сохранить",
        },
        fileUploader: {
            refreshUpload: "Повторить",
            successUpload: "Готово",
            title: "Загрузка файла",
            filesCount: "Загружено %s из %s",
            errors: {
                title: "Ошибка при загрузке",
                fileSize:
                    "Размер файла не должен превышать %s.! Вы пытаетесь загрузить файл размером %s.",
                maxFiles:
                    "За раз можно загружать не более %s файлов, а вы пытаетесь загрузить %s файлов",
            },
        },
    },
    userSelect: {
        multiplePlaceholder: "Выберите пользователей",
        list: {
            title: "Добавить пользователей",
            roles: "По Роли",
            tradePoints: "По Кофейне",
            cities: "По городу",
            allList: "По ФИО",
            addBtn: "Добавить",
            fields: {
                fullName: "ФИО",
                role: "Роль",
                tradePoints: "Кофейня",
                phone: "Телефон",
                imageId: "Фото",
            },
        },
    },
};
export default ruComponents;
